import { t } from "@/i18n-js/instance";
import { FeatureRow } from "../FeatureRow";
import { SectionWrapper } from "./SectionWrapper";
import { annualOnlyKey } from "./constants";

export const Support = () => (
  <SectionWrapper sectionName={t("pricing_plans.section.support")}>
    <FeatureRow
      title={t("pricing_plans.feature.circle_community")}
      basic
      professional
      enterprise
      business
    />
    <FeatureRow
      title={t("pricing_plans.feature.support_basic")}
      basic
      professional
      enterprise
      business
    />
    <FeatureRow
      title={t("pricing_plans.feature.support_priority")}
      basic={false}
      professional={false}
      business={false}
      enterprise={t(annualOnlyKey)}
    />
    <FeatureRow
      title={t("pricing_plans.feature.beta_features")}
      basic={false}
      professional={false}
      business={false}
      enterprise={t(annualOnlyKey)}
    />
  </SectionWrapper>
);
